module.exports = __webpack_public_path__ + "static/media/TestLogo.bdb85b72.svg";